import PropTypes from "prop-types";
import React from "react";
import SimulationTooltip from "./SimulationTooltip";

function Errors(props) {
  const { errors } = props;

  // Render
  return (
    <div className="alert alert-danger">
      <ul>
        {errors.map((error) => (
          <SimulationTooltip key={error} title=".alert li">
            <li key={error}>{error}</li>
          </SimulationTooltip>
        ))}
      </ul>
    </div>
  );
}

Errors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};

Errors.defaultProps = {
  errors: [],
};

export default Errors;
